var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"btn btn-arrow btn-sm",attrs:{"href":_vm.link,"target":_vm.target}},[_vm._v(_vm._s(_vm.label)),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"arrow"},[_c('span',{staticClass:"arrow-inner"})])
}]

export { render, staticRenderFns }